module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-700.2735a3a.woff2";